import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { IonButton } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { asyncScheduler, combineLatest, firstValueFrom, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, skipWhile, take, takeUntil, tap } from 'rxjs/operators';
import { selectEcommerceConfigProgramId } from '../../../store/selectors/ecommerce-config.selectors';
import { selectOrdersState } from '../../../store/selectors/ecommerce-orders.selectors';

import { Buttoms, DefaultListOrder } from '../../../private/shared/models/order-list';
import {
  EDefultCanje,
  INivelesPromo,
  IProductos,
  IPromosEcommerce,
  ISummaryPrice,
} from '../../../private/shared/models/productos';
import { TransferDataService } from '../../../private/shared/services/transfer-data.service';
import { ModalsService } from '../../../shared/services/modals/modals.service';
import { addCartPromoState, removeCartPromoState } from '../../../store/actions/ecommerce.actions';
import { AppState } from '../../../store/app-reducers';
import { CartProductsState } from '../../../store/reducers';
import { buildConfirmRemovePromotion } from '../../configs/modal-configs';
import { EAnalyticsEvents, ESectionProperty } from '../../enums/analytics.enum';
import { AddCartPage } from '../../modals/add-cart/add-cart.page';
import { PromoDetailPage } from '../../modals/promo-detail/promo-detail.page';
import { LocationIdPromos, TCreativeName, TCretiveSlot } from '../../models/Analytics';
import { ILimitsToast } from '../../models/ApplicationUser';
import { GTMInteractions, SummaryPriceDefault } from '../../models/Constants';
import { ModalConfirm } from '../../models/modal-confirm.model';
import { AnalyticsService } from '../../services/analytics.service';
import { OperationsService } from '../../services/operations/operations.service';
import { SharedServiceService } from '../../services/shared-service.service';
import { ToastControllerService } from '../../services/toast-controller.service';

@Component({
  selector: 'promotions-card',
  templateUrl: './promotions-card.component.html',
  styleUrls: ['./promotions-card.component.scss'],
})
export class PromotionsCardComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('addPromo', { static: false }) addPromoBtn: IonButton = {} as IonButton;

  @Input() promo: IPromosEcommerce = {} as IPromosEcommerce;
  @Input() iwantit = false; // Botón desplegar detalle promo
  @Input() last? = false;
  @Input() locationIdPromos: LocationIdPromos = 'Top';
  @Input() index = 0;

  @Output() promosCartEvent = new EventEmitter<IPromosEcommerce>();
  @Output() productosPromocionEvent = new EventEmitter<IProductos[]>();
  @Output() cartPromoProductsEvent = new EventEmitter<IProductos[]>();
  @Output() NivelesPromoEvent = new EventEmitter<INivelesPromo[]>();
  @Output() disabledEdit = new EventEmitter<boolean>();
  @Output() cancelPromo = new EventEmitter<CustomEvent | MouseEvent>();
  @Output() exchangeEvent = new EventEmitter<number>();
  @Output() levelStairs = new EventEmitter<number>();
  @Output() level = new EventEmitter<number>();

  public exchange = 0;
  public isIOS = false;
  public isAndroid = false;
  public detailsStatic = false;
  public resetRange = false;
  public initView = false;
  public imgPromoCart = './assets/common/promo-cart.png';
  public productosPromocion: IProductos[] = [];
  public cartPromoProducts: IProductos[] = [];
  public NivelesPromo: INivelesPromo[] = [];
  public promosCart: IPromosEcommerce = this.promo;
  public promoAvailable = { PaquetesCanjeados: 0, MaximoPaquetes: 0 };
  public canjeEnabled = { isVisible: false, isActive: false, isCheck: false, maximum: 0 };
  public rangeInputEstatic: Buttoms = DefaultListOrder.componentContent.range.buttoms; // Selector Canje Estatitco
  public Programa: Observable<any> = new Observable();

  private modalConfirmRemove: ModalConfirm
  private isMax = false;
  private initialCanje = 1;
  private LimitMaxCajas = 0;
  private LimitMaxMonto = 0;
  private summaryPrice: ISummaryPrice = SummaryPriceDefault;
  private finishSubscriptions: Subject<boolean> = new Subject();
  private cartPromos: IPromosEcommerce[] = []
  private prevCartPromoProducts: IProductos[] = [];
  private prevExchange = 0;
  private addPromoLabels = {
    wantIt: '',
    add: '',
    update: ''
  };

  constructor(
    private transferDataS: TransferDataService
    , private operationsS: OperationsService
    , private toastS: ToastControllerService
    , private analyticsS: AnalyticsService
    , private translate: TranslateService
    , private modalsS: ModalsService
    , private store: Store<AppState>
    , private router: Router
    , private sharedService: SharedServiceService
  ) {
    this.isIOS = Capacitor.getPlatform() === 'ios' && Capacitor.isNativePlatform();
    this.isAndroid = Capacitor.getPlatform() === 'android' || !Capacitor.isNativePlatform();
    this.Programa = this.store.select(selectEcommerceConfigProgramId);
  }

  async ngOnInit() {
    this.modalConfirmRemove = buildConfirmRemovePromotion(this.translate)
    this.LimitMaxCajas = this.operationsS.LimitMaxCajas || 0;
    this.LimitMaxMonto = this.operationsS.LimitMaxMonto || 0;
    const fillter = (value: any) => value.ClavePromo === this.promo.ClavePromo;
    // ? Obtiene las promociones y productos si estan en un pedido actual
    const getOrders$ = this.store.select(selectOrdersState)
      .pipe(
        skipWhile(x => !x.success && !x.failed),
        map(value => value.respPedidos.pedido_actual),
        map(pa => pa?.filter(p => p.status === 1) || []),
      )

    // * Agrega los promos y productos del pedido en curso, como carrito temporal, cuando actualize obtiene como carrito
    combineLatest([getOrders$, this.operationsS.combinerCartOrder$()])
      .pipe(
        map(([orders, cart]) => {
          const pedidoActualPromos = orders.length < 1 ? [] : orders[0].Promos?.filter(fillter).map(p => ({ ...p, isCarrito: false }));
          const prdtsAtlPromos = orders.length < 1 ? [] : orders[0].ProductsPromos?.filter(pp => pp.ClavePromo === this.promo.ClavePromo).map(p => this.operationsS.formatResult(p, false));

          const promo = cart.promo.filter(fillter) || [];
          const cartPromos = cart.cartPromos.filter(fillter);
          return { promo: (promo.length < 1 ? pedidoActualPromos : promo) || [], cartPromos: (cartPromos.length < 1 ? prdtsAtlPromos : cartPromos) || [] };
        }),
        tap(({ promo }) => {
          this.promosCart = promo.length > 0 ? { ...promo[0], Niveles: this.promo.Niveles } : { ...this.promo, PaquetesCanjeados: 0 }
          this.promosCartEvent.emit(this.promosCart);
        }),
        tap(() => this.promoAvailable = { PaquetesCanjeados: this.promoCanje(), MaximoPaquetes: this.promo.MaximoPaquetes }),
        distinctUntilChanged((old, crt) =>
          this.transferDataS.sumTotal(old.cartPromos, 'productos') === this.transferDataS.sumTotal(crt.cartPromos, 'productos')
        ),
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(this.callbackCombineProductsCart);

    this.operationsS.summaryPriceTotal$()
      .pipe(
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(summaryPrice => this.summaryPrice = summaryPrice);
    this.isMax = this.LimitMaxMonto > 0 && this.summaryPrice.total_precio > this.LimitMaxMonto || this.LimitMaxCajas > 0 && (this.summaryPrice.FactorCl || 0) > this.LimitMaxCajas;

    this.imgPromoCart = this.translate.instant('Icons.generic-promo');

    this.store.select('cartProducts')
      .pipe(
        debounceTime(500),
        tap(cart => this.prevCartPromoProducts = cart.cartPromos.filter(product => product.ClavePromo === this.promo.ClavePromo)),
        tap(cart => {
          const cartPromoFiltered = cart.promo.filter(product => product.ClavePromo === this.promo.ClavePromo);
          this.prevExchange = cartPromoFiltered.length > 0 ? cartPromoFiltered[0].PaquetesCanjeados : 0;
        }),
        takeUntil(this.finishSubscriptions)
      ).subscribe(() => { });

    this.addPromoLabels = {
      wantIt: this.translate.instant('Buttons.i-love-you'),
      add: this.translate.instant('Buttons.add'),
      update: this.translate.instant('Buttons.upgrade')
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('promo')
      && changes.promo.previousValue
      && changes.promo.currentValue.ID_Promocion !== changes.promo.previousValue.ID_Promocion
    ) {
      this.detailsStatic = false;
      this.finishSubscriptions.next(true);
      this.finishSubscriptions.complete();
      this.ngOnInit();
      this.ngAfterViewInit();
    }
  }

  ngAfterViewInit(): void {
    // * Color de exclusivo
    if (this.promo.Exclusivo || this.promo.Sunday) {
      asyncScheduler.schedule(() => {
        const element = document.getElementById(`ribbon-${this.promo.ClavePromo}`);
        if (element) {
          const styleElem = element.appendChild(document.createElement('style'));
          styleElem.innerHTML = `#ribbon-${this.promo.ClavePromo}::before,#ribbon-${this.promo.ClavePromo}::after {border-color: ${this.promo.Color};}`;
        }
      }, 500);
    }
  }

  ngOnDestroy() {
    this.transferDataS.onZoomDismiss();
    this.modalsS.modalDismiss();

    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  /**
   * Callback de los productos de la promocion de la BD y estado del Carrito
   */
  private callbackCombineProductsCart = (cartState: CartProductsState | any) => {
    this.productosPromocion = this.promo.Productos || [];
    this.productosPromocionEvent.emit(this.productosPromocion);

    this.exchange = cartState.promo.length > 0 ? cartState.promo[0].PaquetesCanjeados : EDefultCanje[this.promo.TipoPromocion];
    this.exchangeEvent.emit(this.exchange);
    this.initialCanje = EDefultCanje[this.promo.TipoPromocion];

    this.cartPromoProducts = cartState.cartPromos.length < 1 ? this.productosPromocion :
      this.productosPromocion.map(pp => {
        const findDynamic = (x: IProductos) => x.Nivel === pp.Nivel && x.id_producto === pp.id_producto;
        const findStairs = (x: IProductos) => x.id_producto === pp.id_producto;
        const index = cartState.cartPromos.findIndex(this.promo.TipoPromocion === 'ESCALERA' ? findStairs : findDynamic);
        if (index >= 0) {
          const product = cartState.cartPromos[index];
          return {
            ...product,
            productos: (product.productos || 0) / this.exchange
          };
        }
        return pp;
      });
    this.cartPromoProductsEvent.emit(this.cartPromoProducts);

    if (this.promosCart.Niveles.length > 0) {
      this.NivelesPromo = this.promosCart.Niveles.map(level => {
        const cartLevelProduct = this.cartPromoProducts.filter(x => x.Nivel === level.Nivel);
        return {
          ...level,
          Minimo: cartLevelProduct.map(x => x.productos).reduce((a, b) => (a || 0) + (b || 0), 0)
        }
      }) as INivelesPromo[];
      this.NivelesPromoEvent.emit(this.NivelesPromo);
    }

    this.level.emit(this.validLevels() ? 0 : this.NivelesPromo.length + 1);
    this.disabledEdit.emit(this.validLevels());

    this.canjeEnabled = this.visibleRedeem(this.promo);

    const selected = this.transferDataS.sumTotal(this.cartPromoProducts, 'productos');
    const minimum = this.promo.Niveles.filter(n => selected >= n.Minimo && selected <= n.Maximo);
    this.levelStairs.emit(minimum.length > 0 ? minimum[0].Nivel : 0);

    asyncScheduler.schedule(() => this.initView = true, 50);
  }

  /** Zoom de la imagen de la promocion */
  public onZoom = async (image: string) => {
    this.transferDataS.onZoomDismiss();
    await this.transferDataS.onZoom(image);
  }

  /** Agrega los paquetes a canjear */
  public addExchange = async (select: number) => {
    if (!this.initView) { return; }
    if (!this.isMax) {
      // * Validación de precio maximo
      const cartProductsPrice = this.cartPromoProducts.map(p => ((p.productos || 0) * this.promosCart.PaquetesCanjeados) * (p.precio || 0)).reduce((a, b) => a + b);
      const productsPrice = this.productosPromocion.map(p => ((p.productos || 0) * select) * (p.precio || 0)).reduce((a, b) => a + b);
      const totalPrice = this.summaryPrice.total_precio - cartProductsPrice;
      const priceSelected = productsPrice + totalPrice;
      if (this.LimitMaxMonto > 0 && priceSelected > this.LimitMaxMonto) {
        await this.toastS.dismissToast();
        const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-prices');
        this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxMonto.toString()), color, icon, duration, clase, position, header);
        this.resetRange = true;
        this.initView = false;
        asyncScheduler.schedule(() => this.resetRange = false, 50);
        asyncScheduler.schedule(() => this.initView = true, 60);
        return;
      }

      // * Validación de cajas maximo
      const cartProductsBoxs = this.cartPromoProducts.map(p => ((p.FactorCl || 0) * (p.productos || 0)) * this.promosCart.PaquetesCanjeados).reduce((a, b) => a + b);
      const productsBoxs = this.productosPromocion.map(p => ((p.FactorCl || 0) * (p.productos || 0)) * select).reduce((a, b) => a + b);
      const totalCajas = ((this.summaryPrice.FactorCl || 0) - cartProductsBoxs) + productsBoxs;
      if (this.LimitMaxCajas > 0 && totalCajas > this.LimitMaxCajas) {
        await this.toastS.dismissToast();
        const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-boxs');
        this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxCajas.toString()), color, icon, duration, clase, position, header);
        this.resetRange = true;
        asyncScheduler.schedule(() => this.resetRange = false, 50);
        return;
      }
    }

    this.exchange = select;
    if (this.promo.TipoPromocion === 'ESTATICO') {
      this.canjeEnabled = this.visibleRedeem(this.promo);
    }
  }

  /** Indica cuantas promos ha canjeado el usuario vs el maximo de canje */
  public promoCanje = () =>
    this.promo.MaximoPaquetes - (this.promo.PaquetesCanjeados - this.promo.UltimosCanjeados > 0
      ? this.promo.PaquetesCanjeados -
      this.promo.UltimosCanjeados +
      this.promosCart.PaquetesCanjeados
      : this.promosCart.PaquetesCanjeados);

  /**
   * Agrega promo estatica al estado del carrito
   */
  public onAddPromoStatic = async () => {
    // * Validación de precio maximo
    const cartProductsPrice = this.cartPromoProducts.map(p => ((p.productos || 0) * this.promosCart.PaquetesCanjeados) * (p.precio || 0)).reduce((a, b) => a + b);
    const productsPrice = this.productosPromocion.map(p => ((p.productos || 0) * this.exchange) * (p.precio || 0)).reduce((a, b) => a + b);
    const totalPrice = this.summaryPrice.total_precio - cartProductsPrice;
    const priceSelected = productsPrice + totalPrice;
    if (this.LimitMaxMonto > 0 && priceSelected > this.LimitMaxMonto) {
      await this.toastS.dismissToast();
      const { message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-prices');
      this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxMonto.toString()), color, icon, duration, clase, position);
      return;
    }

    // * Validación de cajas maximo
    const cartProductsBoxs = this.cartPromoProducts.map(p => ((p.FactorCl || 0) * (p.productos || 0)) * this.promosCart.PaquetesCanjeados).reduce((a, b) => a + b);
    const productsBoxs = this.productosPromocion.map(p => ((p.FactorCl || 0) * (p.productos || 0)) * this.exchange).reduce((a, b) => a + b);
    const totalCajas = ((this.summaryPrice.FactorCl || 0) - cartProductsBoxs) + productsBoxs;
    if (this.LimitMaxCajas > 0 && totalCajas > this.LimitMaxCajas) {
      await this.toastS.dismissToast();
      const { message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-boxs');
      this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxCajas.toString()), color, icon, duration, clase, position);
      return;
    }

    // Se obtiene el ultimo dato de las promociones agregadas al carrito
    this.cartPromos = await firstValueFrom(this.store.select('cartProducts').pipe(take(1), map(value => value.promo)));

    if (this.exchange > 0) {
      this.store.dispatch(addCartPromoState({ promo: this.promo, cartPromos: this.promo.Productos || [], promoSelect: this.exchange }));
      this.modalsS.modalAddCart(AddCartPage, {
        ...this.promo,
        PaquetesCanjeados: this.exchange,
        Productos: this.productosPromocion.map(p => ({ ...p, productos: (p.productos || 0) * this.exchange })),
        imagen_url: this.imgPromoCart,
      });
    } else {
      // Quita la promo del carrito
      const confirm = await this.modalsS.modalConfirm(this.modalConfirmRemove);
      if (confirm) {
        this.store.dispatch(removeCartPromoState({ ClavePromo: this.promo.ClavePromo }));
      } else {
        this.addExchange(1);
      }
    }

    this.sendEventClickPromo();
    this.sendEventAddRemoveStaticPromo();
    this.sendEventClickPromoV2(this.promo, this.router.url);
  }

  /**
   * Si se muestra el componente de canje de promos,
   * este habilitado el canje
   * estatus del icono,
   * dependieno del tipo de promo
   */
  private visibleRedeem = (promo: IPromosEcommerce) => {
    const maximum = promo.MaximoPaquetes - (promo.PaquetesCanjeados - promo.UltimosCanjeados);
    const canjeEnabled = {
      isVisible: true,
      isActive: this.cartPromoProducts.length > 0,
      isCheck: this.exchange === promo.MaximoPaquetes -
        (promo.PaquetesCanjeados - promo.UltimosCanjeados),
      maximum
    };

    const end = canjeEnabled.maximum;
    const initial = this.initialCanje;
    this.rangeInputEstatic = { ...this.rangeInputEstatic, end, initial };
    return canjeEnabled;
  }

  /** Si cumple con los niveles */
  public validLevels = () => this.NivelesPromo.some(n => n.Maximo > n.Minimo);

  /** Deriva el contexto de analytics (creativeName, creativeSlot, section, itemListName) basado en la ruta actual */
  private getPromoAnalyticsContext(origin: string) {
    const isHome = origin === '/main/Tienda';
    return {
      creativeName: (isHome ? 'Carrusel home' : 'Lista promociones') as TCreativeName,
      creativeSlot: (isHome ? 'carrusel_home' : 'lista_promociones') as TCretiveSlot,
      section: isHome ? 'Home' : 'PLP',
      itemListName: isHome ? this.analyticsS.getListName('Home', 'Carrusel', 'Promociones') : this.analyticsS.getListName('Promoción', 'Listado', 'Promociones'),
    };
  }

  /**
   * Abre el detalle de la promo dinamica o estatica
   */
  public onBuildPromo = async () => {
    this.sendEventClickPromoV2(this.promo, this.router.url);
    const promoAddded = await this.modalsS.modalDetailPromo(PromoDetailPage, this.promo);
    if (promoAddded) {
      this.sendEventClickPromo();
      await this.sendEventAddPromo();

    }
  }
  private sendEventClickPromoV2 = (promo: IPromosEcommerce, origin: string): void => {
    const { creativeName, creativeSlot, itemListName } = this.getPromoAnalyticsContext(origin);
    const searchEvent = {
      ...EAnalyticsEvents.selectPromotion,
      ecommerce: {
        item_list_id: 'promociones',
        item_list_name: itemListName,
        section: ESectionProperty.promociones,
        items: this.analyticsS.getSinglePromoAsList(promo, creativeName, creativeSlot, this.locationIdPromos, this.index)
      }
    };
    this.analyticsS.sendEventGTM(searchEvent, { addUserProps: false, addEnvironmentProps: true });
  }

  /** Cierra de detalle de la promo */
  public onCancel = async (event: CustomEvent | MouseEvent) => this.cancelPromo.emit(event);

  /** Envia un evento de analytics al dar click al agregar una promocion */
  private sendEventClickPromo = (): void => {
    const addPromoTextButton = this.promo.TipoPromocion === 'ESTATICO' && this.prevExchange === 0 ? this.addPromoLabels.wantIt : this.prevExchange === 0 ? this.addPromoLabels.add : this.addPromoLabels.update;
    const btnInteractionEvent = {
      gtmEvent: {
        ...GTMInteractions.addRemovePromotionEvent.gtmEvent,
        accion: this.router.url.includes('Promociones') ? '/tienda_listado_promociones' : '/tienda_lista_productos',
        etiqueta: `${this.promo.Promocion}: ${addPromoTextButton}`
      }
    };
    this.analyticsS.sendEventAnalytics(btnInteractionEvent);
  }

  /**
   * Envia un evento de analytics al agregar o remover una promocion estatica del carrito
   */
  private sendEventAddRemoveStaticPromo = (): void => {
    const origin = this.router.url
    const inCartPromo = this.cartPromos.filter(promo => promo.ClavePromo === this.promo.ClavePromo);
    const prevRedeemed = inCartPromo.length > 0 ? inCartPromo[0].PaquetesCanjeados : 0;

    const typeEvent = this.exchange === prevRedeemed ? 'equal' : this.exchange < prevRedeemed ? 'removeFromCart' : 'addToCart';

    if (typeEvent !== 'equal') {
      const promoQuantity = typeEvent === 'removeFromCart'
        ? inCartPromo[0].PaquetesCanjeados - this.exchange
        : inCartPromo.length > 0 ? this.exchange - inCartPromo[0].PaquetesCanjeados
          : this.exchange;

      const { creativeName, creativeSlot, section, itemListName } = this.getPromoAnalyticsContext(origin);
      const itemCartPromo = {
        ...this.promo,
        Productos: this.promo.Productos.map(p => ({
          ...p,
          productos: p.productos * promoQuantity
        }))
      }
      const promosItems = this.analyticsS.getProductItemsPromo({ ...itemCartPromo, PaquetesCanjeados: 0 }, promoQuantity, "promociones", itemListName, creativeName, creativeSlot)

      this.analyticsS.clearEcommerceEvents();
      const totalValue = promosItems.items.reduce((acc, item) => acc + (item.price * item.quantity), 0);
      const event = {
        ...EAnalyticsEvents[typeEvent],
        ecommerce: {
          value: totalValue,
          section,
          currency: 'MXN',
          items: promosItems.items
        }
      };
      typeEvent === 'removeFromCart' ? this.sharedService.removeCartItemsAnalitycsStorage(promosItems, this.promo.ClavePromo) : this.sharedService.addCartItemsAnalitycsStorage(promosItems, this.promo.ClavePromo)
      this.analyticsS.sendEventGTM(event, { addEnvironmentProps: true })
    }
  }

  /**
   * Envia un evento de analytics al agregar o remover una promocion dinamica o escalera al carrito
   */
  private sendEventAddPromo = async () => {
    const origin = this.router.url;
    const { creativeName, creativeSlot, section, itemListName } = this.getPromoAnalyticsContext(origin);

    const inCartProducts = await firstValueFrom(this.store.select('cartProducts').pipe(
      take(1),
      map(cp => cp.cartPromos.filter(cp => cp.ClavePromo === this.promo.ClavePromo)),
    ));

    const promosItems = this.analyticsS.getProductItemsPromo({ ...this.promo, Productos: inCartProducts, PaquetesCanjeados: 0 }, Math.abs(this.exchange - this.prevExchange), "promociones", itemListName, creativeName, creativeSlot)


    //no habia promos, entonces se estan agregando
    if (this.prevCartPromoProducts.length === 0) {
      this.analyticsS.clearEcommerceEvents();
      const event = {
        ...EAnalyticsEvents.addToCart,
        ecommerce: {
          value: promosItems.items.reduce((acc, item) => acc + (item.price * item.quantity), 0),
          section,
          currency: 'MXN',
          items: promosItems.items
        }
      };
      await this.sharedService.addCartItemsAnalitycsStorage(promosItems, this.promo.ClavePromo)
      await this.analyticsS.sendEventGTM(event, { addEnvironmentProps: true })
    } else {

      const [addedItems, removedItems] = this.analyticsS.getlAllItemsPromoAgregadosOEliminados(promosItems, this.promo, this.prevCartPromoProducts, this.prevExchange, itemListName);

      this.analyticsS.clearEcommerceEvents();
      if (removedItems.length > 0) {
        const eventRemove = {
          ...EAnalyticsEvents.removeFromCart,
          ecommerce: {
            value: removedItems.reduce((acc, item) => acc + (item.price * item.quantity), 0),
            section,
            currency: 'MXN',
            items: removedItems
          }
        };
        await this.sharedService.removeCartItemsAnalitycsStorage({ items: removedItems }, this.promo.ClavePromo)
        await this.analyticsS.sendEventGTM(eventRemove, { addEnvironmentProps: true })

        this.analyticsS.clearEcommerceEvents();
      }

      if (addedItems.length > 0) {
        const eventAdd = {
          ...EAnalyticsEvents.addToCart,
          ecommerce: {
            value: addedItems.reduce((acc, item) => acc + (item.price * item.quantity), 0),
            section,
            currency: 'MXN',
            items: addedItems
          }
        };
        await this.sharedService.addCartItemsAnalitycsStorage({ items: addedItems }, this.promo.ClavePromo)
        await this.analyticsS.sendEventGTM(eventAdd, { addEnvironmentProps: true })
      }


    }
  }

}
